import {
  CloudArrowUpIcon,
  LockClosedIcon,
  ServerIcon,
} from "@heroicons/react/20/solid";
import Table from "../../assets/table.jpg";
import milelebenefits from "../../assets/milelebenefits.jpg"

export default function MileleHealthPlan() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
     
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">
                Health Insurance
              </p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Milele Health Plan
              </h1>
              <p className="mt-6 text-xl leading-8 text-gray-700">
                Britam Milele is the perfect health protection. It manages you
                and your families’ health related needs right from
                hospitalization to post-hospitalization. The product takes care
                of inpatient claims and is designed to suit your need and is
                pocket friendly. The plans are available for individuals and
                families.{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            src={milelebenefits}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <div className="my-4">
                <p>
                  <b>Benefits offered by the Britam Milele Health Plan:</b>
                </p>
                <ul className="list-disc list-inside">
                  <li>Inpatient and Outpatient</li>
                  <li>Lifetime cover</li>
                  <li>Overseas Treatment</li>
                  <li>Free Personal Accident & Critical illness cover</li>
                  <li>
                    Free professional consultation in Stress management,
                    nutrition & health
                  </li>
                </ul>
              </div>

              <div className="my-4">
                <p>
                  To provide you with best health insurance coverage and to let
                  you decide the right policy that suits your needs, we have
                  made 4 plan variants available:{" "}
                </p>
                <ul className="list-disc list-inside">
                  <li>Advantage</li>
                  <li>Premier</li>
                  <li>Essential 1</li>
                  <li>Essential 2</li>
                </ul>
              </div>
       
             
            </div>
          </div>
        </div>
        <div className="pl-20">

<h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
Check out the rate cards and the hospitals panels below.
</h2>
<div>
  <table>
      <thead>
          <tr>
              <th className="">DOWNLOADS</th>
              <th className="px-4">ADVANTAGE</th>
              <th className="px-4">PREMIER</th>
              <th className="px-4">ESSENTIAL 1</th>
              <th className="px-4">ESSENTIAL 2</th>
          </tr>
      </thead>
      <tbody>

        <tr>
            <td>Rate card </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
        </tr>
        <tr>
            <td>Hospital Panel </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
            <td className="px-4">Download </td>
        </tr>
        


        
      </tbody>
  </table>
  </div>
  </div>
      </div>
      
    </div>
  );
}
